import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import db from '../firebase';
import { Grid, Card, Typography, Paper, Box, Container } from '@mui/material';
//import { Delete as DeleteIcon, Article as ArticleIcon, Favorite as FavoriteIcon, FavoriteBorder as FavoriteBorderIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon, ArticleOutlined as ArticleOutlinedIcon } from '@mui/icons-material';
import axios from 'axios';
import { collection, getDocs, updateDoc, doc, getDoc, deleteDoc, addDoc, query, limit, orderBy, writeBatch, where } from 'firebase/firestore';
import OpenAI from "openai";
//import placeholderImage from '../assets/placeholderImage.svg'; // Add a placeholder image in your assets
import * as cheerio from 'cheerio';
import { FeedbackContext } from '../contexts/FeedbackContext';
import '../styles/displayarticles.css';
import '../styles/articlecard.css';
import { MetadataContext } from '../contexts/MetadataContext';
import { SpinnerContext } from '../contexts/SpinnerContext';
import { useArticles } from '../contexts/ArticlesContext';
//import parse from 'html-react-parser';
import SearchControls from './searchControls';
import ArticleCardContent from './ArticleCardContent';
import ArticleCardActions from './ArticleCardActions';
import ArticleDialog from './ArticleDialog';
import { useAuth } from '../contexts/AuthContext';


const DisplayArticles = () => {
    const { articles, setArticles, fetchNextArticles, handleFavoriteArticle, lastVisible, handleTagChange } = useArticles();
    const [selectedArticles, setSelectedArticles] = useState([]);
    const [expandedArticleId, setExpandedArticleId] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);
    const [processingCount, setProcessingCount] = useState(0);
    const [startTime, setStartTime] = useState(null);
    const [setResponse] = useState({
        title: "",
        subtitle: "",
        articles: []
    });
    //const [imageAccessibility, setImageAccessibility] = useState({});
    const [filter, setFilter] = useState('new'); // Filter state
    //const [dialogOpen, setDialogOpen] = useState(false); // State to manage dialog open/close
    const { showFeedback } = useContext(FeedbackContext);
    const { metadata, totalArticleCount, } = useContext(MetadataContext);
    const { showSpinner, hideSpinner } = useContext(SpinnerContext);
    const [expanded, setExpanded] = React.useState(false);
    const observer = useRef();
    const lastArticleElementRef = useRef();
    const availableTags = metadata.tags || [];
    const memoizedAvailableTags = useMemo(() => availableTags, [availableTags]);
    const { currentUser } = useAuth();
    //console.table('tags: ',availableTags);
    // Add a new state to track if we're showing search results
    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        if (observer.current && lastVisible != null) observer.current.disconnect();
        
        // Don't set up observer if we're showing search results
        if (isSearching) {
            return;
        }
console.log("Is searching: ", isSearching);

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting ) {
                fetchNextArticles().then(showFeedback('Fetching more articles now...')); // Fetch next set of articles

            }
        });
        if (lastArticleElementRef.current) {
            observer.current.observe(lastArticleElementRef.current);
        }
    }, [articles, isSearching]);

    const OPENAI_API_KEY = metadata.OPENAI_API_KEY || "";
    const maxArticles = metadata.maxArticles;
    //console.log(maxArticles);

    const handleDialogOpen = (article) => {
        setSelectedArticle(article);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setSelectedArticle(null);
    };

    const handleExpandCard = () => {
        setExpanded(!expanded);
    };

    const openai = new OpenAI({
        apiKey: OPENAI_API_KEY,
        dangerouslyAllowBrowser: true //API key is exposed in the browser but only fetched from metadata when user logs in
    });

    const handleSelectArticle = useCallback((article) => {
        if (selectedArticles.includes(article)) {
            setSelectedArticles(selectedArticles.filter(a => a !== article));
        } else {
            setSelectedArticles([...selectedArticles, article]);
        }
        console.log('Selected Articles:', selectedArticles); // Debugging line
    }, [selectedArticles]);

    const handleExpandClick = useCallback((articleId) => {
        setExpandedArticleId(expandedArticleId === articleId ? null : articleId);
    }, [expandedArticleId]);

    const handleDelete = useCallback(async (id) => {
        try {
            await deleteDoc(doc(db, 'articles', id));
            // Optionally, update the UI by removing the deleted article from the state
            setArticles((prevArticles) => prevArticles.filter(article => article.id !== id));
            showFeedback('Article deleted successfully', 'success');
        } catch (error) {
            console.error('Error deleting article:', error);
            showFeedback('An error occurred while deleting the article', 'error');
        }
    }, [setArticles, showFeedback]);



    const extractTitlesAndDescriptions = (articles) => {
        const now = new Date();
        const twoDaysAgo = new Date(now.getTime() - 48 * 60 * 60 * 1000);

        return articles
            .filter(article => new Date(article.pubDate) >= twoDaysAgo)
            .map(article => ({
                title: article.title,
                documentID: article.id
            }));
    };

    const formatPrompt = (articles, type) => {
        const titlesAndDescriptions = extractTitlesAndDescriptions(articles);
        console.log(titlesAndDescriptions);
        const formattedList = titlesAndDescriptions.map((item, index) => `${index + 1}. Title: ${item.title}\nDescription: ${item.description}\nDocumentID: ${item.documentID}`).join('\n\n');
        const selected = selectedArticles.map(article => {
            return {
                title: article.title,
                link: article.link,
                cleanDescription: article.cleanDescription,
                diffbotText: article.diffbotData ? article.diffbotData.objects ? article.diffbotData.objects[0].text : null : null
            };
        });

        if (type === 'newsletter') {
            console.log('Selected Articles:', selected); // Debugging line
            return `${metadata.prompt_newsletter}
                        :\n\n${JSON.stringify(selected)}`;
        } else if (type === 'hot_topics') {
            return `${metadata.prompt_hotTopics}\n\n${formattedList}`;
        }
    };

    
    const handleGenerateTLDR = async (article) => {
        const prompt = `Create a TL;DR that captures the essence of the article in one or two sentences, focusing on the main findings and implications without introductory phrases.\n\nArticle: ${article.title}\n\n${article.diffbotData.objects[0].text}`;
        console.log(prompt);
        showSpinner("Generating TL;DR");
        try {
            const response = await openai.chat.completions.create({
                model: "gpt-4o-mini",
                messages: [
                    {
                        "role": "user",
                        "content": [
                            {
                                "type": "text",
                                "text": prompt
                            }
                        ]
                    }],
                temperature: 1,
                max_tokens: 100,
                top_p: 1,
                frequency_penalty: 0,
                presence_penalty: 0,
            });
            if (response.choices && response.choices.length > 0) {
                const tldr = response.choices[0].message.content;
                // Save request and response to Firestore
                await updateDoc(doc(db, 'articles', article.id), {
                    TLDR: tldr
                });

                // Update the local state with the new TL;DR
                setArticles(prevArticles =>
                    prevArticles.map(a =>
                        a.id === article.id ? { ...a, TLDR: tldr } : a
                    )
                );
                console.log('TL;DR:', tldr);
            }
        } catch (error) {
            console.error('Error generating TL;DR:', error);
        } finally {
            hideSpinner();
        }
    };

    
    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
    };
    const diffbotApiToken = '7376dfff82dd031ade7906d349a75617';

    const handleExtractArticle = async (article) => {

        const diffbotUrl = `https://api.diffbot.com/v3/article?url=${encodeURIComponent(article.link)}&token=${diffbotApiToken}`;
        showSpinner("Fetching article data from Diffbot");
        try {
            const response = await axios.get(diffbotUrl);
            const diffbotData = response.data;
            console.log('Diffbot data:', diffbotData);

            await updateDoc(doc(db, 'articles', article.id), { diffbotData });

            // Fetch the updated article from Firebase
            const updatedArticleDoc = await getDoc(doc(db, 'articles', article.id));
            const updatedArticleData = updatedArticleDoc.data();
            const pubDate = new Date(updatedArticleData.pubDate.seconds ? updatedArticleData.pubDate.seconds * 1000 : updatedArticleData.pubDate);
            const $ = cheerio.load(updatedArticleData.description);
            const cleanDescription = $.text();

            // Update the articles state with the updated article
            setArticles(prevArticles => prevArticles.map(a => a.id === article.id ? { id: updatedArticleDoc.id, ...updatedArticleData, pubDate, cleanDescription } : a));

            //console.log('Article data saved successfully!');
            showFeedback('Article data saved successfully!');
            hideSpinner();
        } catch (error) {
            //console.error('Error fetching data from Diffbot:', error);
            showFeedback('An error occurred while fetching data from Diffbot');
        }
    };

    const filteredArticles = articles.filter(article => article.status === filter);

    async function removeDuplicateEntries() {
        const articlesRef = collection(db, 'articles');
        const snapshot = await getDocs(articlesRef);
        const urlMap = new Map();

        const batch = writeBatch(db);
        let duplicateCount = 0;

        snapshot.forEach(doc => {
            const data = doc.data();
            const url = data.link;

            if (urlMap.has(url)) {
                // If URL already exists, mark this document for deletion
                batch.delete(doc.ref);
                duplicateCount++;
            } else {
                // If URL does not exist, add it to the map
                urlMap.set(url, doc.id);
            }
        });

        // Commit the batch delete operation
        await batch.commit();
        //console.log('Duplicate entries removed successfully.');
        return duplicateCount;
    }

    const handleRemoveDuplicates = async () => {
        try {
            const duplicateCount = await removeDuplicateEntries();
            showFeedback(`Duplicate entries removed successfully. Count: ${duplicateCount}`);
        } catch (error) {
            //console.error('Error removing duplicate entries:', error);
            showFeedback('An error occurred while removing duplicate entries.');
        }
    };


    const fetchArticleData = async (article) => {
        try {
            const response = await axios.get(`https://api.diffbot.com/v3/article?url=${encodeURIComponent(article.link)}&token=${diffbotApiToken}`);
            const diffbotData = response.data;
            // Save diffbot data to Firestore
            await updateDoc(doc(db, 'articles', article.id), {
                diffbotData
            });

            console.log('Diffbot data fetched:', diffbotData);
        } catch (error) {
            console.error('Error fetching article data from Diffbot:', error);
        }
    };

    const processNextArticle = async () => {
        const articlesQuery = query(
            collection(db, 'articles'),
            where('TLDR', '==', null),
            orderBy('pubDate', 'desc'),
            limit(1)
        );

        const querySnapshot = await getDocs(articlesQuery);
        if (querySnapshot.empty) {
            const endTime = new Date();
            const timeDiff = (endTime - startTime) / 1000 / 60; // Time in minutes
            const articlesPerMinute = processingCount / timeDiff;
            console.log(`Processed ${processingCount} articles in ${timeDiff.toFixed(2)} minutes (${articlesPerMinute.toFixed(2)} articles/minute)`);
            return;
        }

        const articleDoc = querySnapshot.docs[0];
        const article = articleDoc.data();
        const articleId = articleDoc.id;

        console.log(`Processing article: ${article.title}`);

        if (!article.diffbotData) {
            console.log(`Fetching article data from Diffbot for article ${article.title}`);
            await fetchArticleData(article);
        }

        if (!article.TLDR) {
            console.log(`Generating TL;DR for article ${article.title}`);
            await handleGenerateTLDR(article);
        }

        setProcessingCount(prevCount => prevCount + 1);
        processNextArticle();
    };

    const startProcessing = () => {
        setStartTime(new Date());
        setProcessingCount(0);
        processNextArticle();
    };



    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={{
                height: 'calc(100vh - 64px)',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                overflow: 'hidden',
                margin: 0,
                padding: 0,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    bgcolor: '#1a1a1a',
                    p: 2,
                    mb: 0,
                    borderRadius: 0,
                    minHeight: '100%',
                    width: '100%',
                    boxSizing: 'border-box'
                }}
            >
                {currentUser?.isAdmin?
                <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
                    {filteredArticles.length} / {totalArticleCount}
                </Typography>:''}

                <SearchControls />

                <Box sx={{
                    width: '100%',
                    overflow: 'auto',
                    maxHeight: 'calc(100vh - 200px)',
                    mt: 2
                }}>
                    <Grid container spacing={2}>
                        {filteredArticles.map((article, index) => {
                            const isSelected = selectedArticles.includes(article);
                            const cardStyle = {
                                backgroundColor: isSelected ? '#f0f0f0' : '',
                                /*transform: isSelected ? 'scale(1.00)' : 'scale(1)',
                                transition: 'transform 0.01s ease-in-out, background-color 0.01s ease-in-out',*/
                                margin: '2px',
                            };
                            if (filteredArticles.length === index + 1 && !isSearching) {
                                return (
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} key={article.id} ref={lastArticleElementRef}>
                                        <Card
                                            sx={{
                                                //maxWidth: 600,
                                                margin: 'auto',
                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                                                backgroundColor: '#202020',
                                                color: '#FFFFFF',
                                                borderRadius: 2,
                                            }}
                                        >    <ArticleCardContent
                                                article={article}
                                                handleSelectArticle={handleSelectArticle}
                                                handleDelete={handleDelete}
                                                selectedArticles={selectedArticles}
                                            />
                                            <ArticleCardActions
                                                article={article}
                                                handleDelete={handleDelete}
                                                handleExtractArticle={handleExtractArticle}
                                                handleTagChange={handleTagChange}
                                                availableTags={memoizedAvailableTags}
                                                handleExpandClick={handleExpandClick}
                                                expandedArticleId={expandedArticleId}
                                                handleFavoriteArticle={handleFavoriteArticle}
                                                handleDialogOpen={handleDialogOpen}
                                                handleGenerateTLDR={handleGenerateTLDR}
                                                //currentUser={currentUser}
                                        
                                            />
                                            {/*<Collapse in={expandedArticleId === article.id} timeout="auto" unmountOnExit>
                                                    <CardContent><Typography variant="body2" className="article-description">
                                                        {article.cleanDescription}
                                                    </Typography>
                                                        <Typography variant="body2" className="article-full-text">
                                                            <span className="article-full-text-bold">TL;DR: </span> {article.TLDR}
                                                        </Typography>
                                                        <IconButton onClick={() => handleExpandClick(article.id)}>
                                                            {expandedArticleId === article.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                        </IconButton>
                                                    </CardContent>
                                                </Collapse>
                                                */}
                                        </Card>
                                    </Grid>
                                );

                            } else {
                                return (
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} key={article.id}>
                                        <Card
                                            sx={{
                                                //maxWidth: 600,
                                                margin: 'auto',
                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                                                backgroundColor: '#202020',
                                                color: '#FFFFFF',
                                                borderRadius: 2,
                                            }}
                                        >     <ArticleCardContent
                                                article={article}
                                                handleSelectArticle={handleSelectArticle}
                                                handleDelete={handleDelete}
                                                selectedArticles={selectedArticles}
                                            />

                                            <ArticleCardActions
                                                article={article}
                                                handleDelete={handleDelete}
                                                handleExtractArticle={handleExtractArticle}
                                                handleTagChange={handleTagChange}
                                                availableTags={memoizedAvailableTags}
                                                handleExpandClick={handleExpandClick}
                                                expandedArticleId={expandedArticleId}
                                                handleFavoriteArticle={handleFavoriteArticle}
                                                handleDialogOpen={handleDialogOpen}
                                                handleGenerateTLDR={handleGenerateTLDR}
                                                currentUser={currentUser}
                                            />
                                            {/*
                                                <Collapse in={expandedArticleId === article.id} timeout="auto" unmountOnExit>
                                                    <CardContent><Typography variant="body2" className="article-description">
                                                        {article.cleanDescription}
                                                    </Typography>
                                                        <Typography variant="body2" className="article-full-text">
                                                            <span className="article-full-text-bold">TL;DR: </span> {article.TLDR}
                                                        </Typography>
                                                        <IconButton onClick={() => handleExpandClick(article.id)}>
                                                            {expandedArticleId === article.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                        </IconButton>
                                                    </CardContent>
                                                </Collapse> 
                                                */}
                                        </Card>
                                    </Grid>
                                );
                            }

                        })}
                    </Grid>
                </Box>



                {dialogOpen && <ArticleDialog
                    open={dialogOpen}
                    onClose={handleDialogClose}
                    article={selectedArticle}
                />}
            </Paper>
        </Container>
    );
};

export default DisplayArticles;
